import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  cartSelector: {
    marginBottom: 'var(--ui-spacer-l)',
  },
  cartLines: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 'var(--ui-spacer-l)',
  },
  sectionTitle: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    lineHeight: 1.143,
    color: 'var(--ui-color-text)',
    marginTop: 0,
    marginBottom: 0,
  },
}))

export default useStyles
